import React, { useState } from 'react';
import styled from 'styled-components';
import { IeltsCalendarModal } from '../Components/IeltsBooking';

const Container = styled.div`
  min-height: 100vh;
  padding: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: 0.5rem;
    min-height: 100vh;
  }
`;

const ContentWrapper = styled.div`
  background: white;
  border-radius: 20px;
  padding: 3rem;
  max-width: 800px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 768px) {
    padding: 1.5rem;
    border-radius: 15px;
    margin: 0.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 1rem;
    border-radius: 10px;
  }
`;

const Title = styled.h1`
  color: #2c3e50;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  font-family: 'Cairo', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
    line-height: 1.3;
  }
`;

const Subtitle = styled.p`
  color: #7f8c8d;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
`;

const FeatureCard = styled.div`
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 15px;
  border-left: 4px solid #3498db;
`;

const FeatureIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
`;

const FeatureTitle = styled.h3`
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const FeatureDescription = styled.p`
  color: #7f8c8d;
  font-size: 0.95rem;
  line-height: 1.5;
`;

const BookingButton = styled.button`
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
  border: none;
  border-radius: 15px;
  padding: 1.2rem 3rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(52, 152, 219, 0.3);
  margin-top: 2rem;
  font-family: 'Cairo', sans-serif;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(52, 152, 219, 0.4);
  }

  &:active {
    transform: translateY(-1px);
  }
  
  @media (max-width: 768px) {
    padding: 1rem 2rem;
    font-size: 1.1rem;
    width: 100%;
    max-width: 300px;
  }
  
  @media (max-width: 480px) {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
  }
`;

const InfoSection = styled.div`
  background: #ecf0f1;
  border-radius: 15px;
  padding: 2rem;
  margin: 2rem 0;
  text-align: left;
`;

const InfoTitle = styled.h3`
  color: #2c3e50;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const InfoList = styled.ul`
  color: #7f8c8d;
  line-height: 1.8;
  padding-left: 1.5rem;
`;

const IeltsRegistration: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [language] = useState<'ar' | 'en'>('en'); // You can integrate this with your app's language state

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Container>
      <ContentWrapper>
        <Title> (ورشة آيلتس من البرتش كاونسل (طلبة بريطانيا</Title>
        {/* <Subtitle>
          Book your IELTS test appointment with ease. Choose your preferred date and time,
          and secure your spot for the International English Language Testing System.
        </Subtitle> */}
{/* 
        <FeatureGrid>
          <FeatureCard>
            <FeatureIcon>📅</FeatureIcon>
            <FeatureTitle>Flexible Scheduling</FeatureTitle>
            <FeatureDescription>
              Choose from available slots Monday to Thursday, 10:30 AM to 6:00 PM
            </FeatureDescription>
          </FeatureCard>

          <FeatureCard>
            <FeatureIcon>⚡</FeatureIcon>
            <FeatureTitle>Instant Confirmation</FeatureTitle>
            <FeatureDescription>
              Get immediate booking confirmation and receive all test details
            </FeatureDescription>
          </FeatureCard>

          <FeatureCard>
            <FeatureIcon>🌐</FeatureIcon>
            <FeatureTitle>Bilingual Support</FeatureTitle>
            <FeatureDescription>
              Available in both English and Arabic for your convenience
            </FeatureDescription>
          </FeatureCard>
        </FeatureGrid>

        <InfoSection>
          <InfoTitle>What to Expect:</InfoTitle>
          <InfoList>
            <li>Complete IELTS test including Listening, Reading, Writing, and Speaking</li>
            <li>Professional test environment with certified examiners</li>
            <li>Results available within 13 calendar days</li>
            <li>Internationally recognized certification</li>
            <li>Test duration: approximately 2 hours and 45 minutes</li>
          </InfoList>
        </InfoSection>

        <InfoSection>
          <InfoTitle>Requirements:</InfoTitle>
          <InfoList>
            <li>Valid passport or national ID</li>
            <li>Arrive 30 minutes before your scheduled time</li>
            <li>No electronic devices allowed in the test room</li>
            <li>Bring a printed copy of your booking confirmation</li>
          </InfoList>
        </InfoSection> */}

        <BookingButton onClick={handleOpenModal}>
        احجز مكانك في ورشة الآيلتس
        </BookingButton>

        <IeltsCalendarModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          language={language}
        />
      </ContentWrapper>
    </Container>
  );
};

export default IeltsRegistration;
